import React from 'react';
import PropTypes from 'prop-types';

const Raw = ({ value, as: Type = 'span', className }) => (
  <Type dangerouslySetInnerHTML={{ __html: value }} className={className} />
);

Raw.propTypes = {
  value: PropTypes.string,
  as: PropTypes.string,
  className: PropTypes.string
};

export default Raw;
